<template>
	<section class="floors_wrapper">
		<portal to="modal">
			<StorePopup v-if="store_modal" />
		</portal>
		<div class="floors_search events-none" ref="floors_search">
			<div class="floors_search__wrapper events-all" v-if="search_val">
				<div class="floors_search__inner container grid">
					<div
						class="floors_search__card flex column pointer pb-40 pl-30 pr-30"
						v-for="(brand, idx) in filteredList"
						@click="select_store_search(brand)"
						:key="idx"
					>
						<div
							class="
                floors_search__card--logo
                flex
                al-center
                justify-center
                mb-34
              "
						>
							<picture>
								<source
									media="(max-width: 767px)"
									:srcset="_.get(brand, 'logo[0].devices.mobile')"
								/>
								<source
									media="(max-width: 1023px)"
									:srcset="_.get(brand, 'logo[0].devices.tablet')"
								/>
								<img :src="_.get(brand, 'logo[0].devices.desktop')" class="obj_contain" alt />
							</picture>
						</div>
						<div class="floors_search__card--content">
							<div class="title font-23 bold mb-13">
								{{ _.get(brand, 'title') }}
							</div>
							<div class="categories mb-13">
								<!-- ტანსაცმელი, ფეხსაცმელი, აქსესუარები -->
								<div v-for="(item, idx) in get_tags(_.get(brand, 'store_categories'))" :key="idx">
									<span class="font-16 medium "> {{ _.get(item, 'title') }}</span>
									<span class="font-16 medium f-gray">{{
										idx == get_tags(_.get(brand, 'store_categories')).length - 1 ? '' : ','
									}}</span>
								</div>
							</div>
							<div
								class="
                  floors_search__card--content-bottom
                  flex
                  al-center
                  between
                "
							>
								<div class="row bold">
									{{ $fn.tr('სართული') + ': ' }}
									<span :key="indx" v-for="(item, indx) in getFloor(_.get(brand, 'floor'))"
										>{{
											_.get(item, 'title') +
												`${indx == getFloor(_.get(brand, 'floor')).length - 1 ? '' : ','}`
										}}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="map" ref="map_parent">
			<div class="svg_viewer__ui">
				<div class="map__filters flex between wc" :class="{ collapsed: filter_collapsed }">
					<div class="map__filters--left-col flex column">
						<div
							class="map__filters--filter flex map__filters--radio_box"
							v-for="(item, index) in store_categories"
							:key="index"
							:stroke_color="_.get(item, 'color.stroke_color')"
							:fill_color="_.get(item, 'color.fill_color')"
						>
							<el-radio
								v-model="radio"
								:label="_.get(item, 'id')"
								@change="
									set_radio_color(
										_.get(item, 'color.fill_color'),
										_.get(item, 'color.stroke_color')
									)
								"
								>{{ _.get(item, 'title') }}</el-radio
							>
						</div>
					</div>
					<div
						class="map__filters--right-col flex al-center pointer"
						@click="filter_collapsed = !filter_collapsed"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="7.857"
							height="10"
							viewBox="0 0 7.857 10"
						>
							<path
								id="Icon_material-play-arrow"
								data-name="Icon material-play-arrow"
								d="M12,7.5v10l7.857-5Z"
								transform="translate(-12 -7.5)"
								fill="#fff"
							/>
						</svg>

						<span class="f-13 bold f-white uppercase">{{ $fn.tr('ფილტრი') }}</span>
					</div>
				</div>
				<div class="map__floors flex column">
					<span class="f-16 bold uppercase f-white">{{ $fn.tr('სართულები') }} </span>
					<div class="flex column">
						<div
							class="
                map__filter-btn
                flex
                al-center
                justify-center
                flex
                pointer
                events-all
              "
							v-for="(item, index) in floors"
							:key="index"
							:class="{
								active: active_floor == parseInt(_.get(item, 'id')),
							}"
							@click="active_floor = parseInt(_.get(item, 'id'))"
						>
							<span class="f-16 bold f-white">{{ _.get(item, 'title') }}</span>
						</div>
					</div>
					<div class="flex column map__zooms">
						<div class="zoom_in map__filter-btn" ref="zoom_in">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="9.45"
								height="9.45"
								viewBox="0 0 9.45 9.45"
							>
								<path
									id="Path_1582"
									data-name="Path 1582"
									d="M11.55-7.581v3.36H8.505v3.045H5.145V-4.221H2.1v-3.36H5.145v-3.045h3.36v3.045Z"
									transform="translate(-2.1 10.626)"
									fill="#fff"
								/>
							</svg>
						</div>
						<div class="zoom_out map__filter-btn" ref="zoom_out">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="9.45"
								height="3.36"
								viewBox="0 0 9.45 3.36"
							>
								<path
									id="Path_1583"
									data-name="Path 1583"
									d="M2.1-7.245h9.45v3.36H2.1Z"
									transform="translate(-2.1 7.245)"
									fill="#fff"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="svg_viewer">
				<div class="svg_viewer__inner" ref="container">
					<div class="svg_viewer__inner--svg" ref="container_svg">
						<!-- <SvgComponents :name="'map'" /> -->
						<div
							class="map__content"
							v-html="_.get(map_svg, 'render_svg')"
							:key="active_floor"
						></div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import SvgComponents from '@/components/SvgComponents';
import fn from '@/helpers/func';
import StorePopup from '@/components/modals/StorePopup';
export default {
	components: { SvgComponents, StorePopup },
	data() {
		return {
			cont_width: '',
			cont_height: '',
			// მაპის კონტენტი
			map_svg: '',
			floors: '',
			active_floor: -1,
			list: '',
			map_data: '',
			selected_store: '',
			selected_store_search: '',
			// store_categories: [],
			//
			filteredList: null,
			//
			// ეს ვ-მოდელები წასაშლელი იქნება მერე
			radio: [],

			//
			filter_collapsed: false,
			// pan vs click failsafe
			orig_pointX: 0,
			orig_pointY: 0,
			allow_click: true,
			start_dist: 0,
			// მაპის რაღაცეები
			scale: 1,
			panning: false,
			pointX: 0,
			pointY: 0,
			start: { x: 0, y: 0 },
			pinch_dist: 0,
			pinched: false,
			ctrl_clicked: false,
			windowWidth: window.innerWidth,
			windowHeight: window.innerHeight,
		};
	},
	props: ['contentData'],
	created() {
		this.get_map_data();
	},
	updated() {},
	mounted() {
		window.addEventListener('resize', this.resize_handler);
		this.$nextTick(() => {
			this.$refs.floors_search.style.height = `${this.windowHeight -
				document.querySelector('.search').getBoundingClientRect().bottom}px`;
		});

		this.$refs.container.style.height = `${this.$refs.map_parent.offsetHeight - 55}px`;
		this.$refs.container.style.width = `${(this.$refs.map_parent.offsetHeight - 55) *
			1.25832492432}px`;
		this.cont_height = this.$refs.map_parent.offsetHeight - 55;
		this.cont_width = (this.$refs.map_parent.offsetHeight - 55) * 1.25832492432;

		if (this.windowWidth <= 1000) {
			this.$refs.map_parent.style.height = `${this.windowWidth * 0.79507618283 + 100}px`;
			this.$refs.container.style.height = `${this.windowWidth * 0.79507618283 + 100}px`;
			this.$refs.container.style.width = `${this.windowWidth}px`;
			this.cont_height = this.windowWidth * 0.79507618283 + 100;
			this.cont_width = this.windowWidth;
		}
		this.$refs.zoom_in.addEventListener('click', () => {
			this.$refs.container_svg.classList.remove('is-transit');

			if (this.windowWidth >= 1001) {
				if (this.scale * 1.1 <= 3.1) {
					this.scale *= 1.1;
				}
			} else {
				if (this.scale * 1.1 <= 3.8) {
					this.scale *= 1.1;
				}
			}
			if (this.pointX == 0) {
				this.pointX = -(
					(this.$refs.container.getBoundingClientRect().width * this.scale -
						this.$refs.container.getBoundingClientRect().width) /
					2
				);
				this.pointY = -(
					(this.$refs.container.getBoundingClientRect().height * this.scale -
						this.$refs.container.getBoundingClientRect().height) /
					2
				);
			} else {
				this.pointX += -(
					(this.$refs.container.getBoundingClientRect().width * this.scale -
						this.$refs.container_svg.getBoundingClientRect().width) /
					2
				);
				this.pointY += -(
					(this.$refs.container.getBoundingClientRect().height * this.scale -
						this.$refs.container_svg.getBoundingClientRect().height) /
					2
				);
			}

			this.$refs.container_svg.classList.add('is-zoomed');

			this.set_pos();
		});

		this.$refs.zoom_out.addEventListener('click', () => {
			if (this.scale / 1.1 >= 1) {
				this.scale /= 1.1;
			}
			this.$refs.container_svg.classList.add('is-zoomed');
			this.$refs.container_svg.classList.remove('is-transit');

			this.pointX -=
				(this.$refs.container.getBoundingClientRect().width * this.scale -
					this.$refs.container_svg.getBoundingClientRect().width) /
				2;
			this.pointY -=
				(this.$refs.container.getBoundingClientRect().height * this.scale -
					this.$refs.container_svg.getBoundingClientRect().height) /
				2;

			this.limit_panning(true);

			this.set_pos();
		});
		this.$refs.container_svg.addEventListener('mousedown', (e) => {
			this.$refs.container_svg.classList.remove('is-transit');
			e.preventDefault();
			this.start = { x: e.clientX - this.pointX, y: e.clientY - this.pointY };
			this.panning = true;
			this.orig_pointX = e.clientX;
			this.orig_pointY = e.clientY;
		});

		this.$refs.container_svg.addEventListener('touchstart', (e) => {
			if (e.touches.length === 2) {
				this.pinched = true;
				this.start_dist = Math.hypot(
					e.touches[0].pageX - e.touches[1].pageX,
					e.touches[0].pageY - e.touches[1].pageY
				);
			} else {
				this.pinched = false;
			}
			this.start = {
				x: e.touches[0].clientX - this.pointX,
				y: e.touches[0].clientY - this.pointY,
			};
			this.panning = true;
			this.orig_pointX = e.touches[0].clientX;
			this.orig_pointY = e.touches[0].clientY;
		});

		this.$refs.container_svg.addEventListener('mouseup', (e) => {
			let diff_x, diff_y;
			this.panning = false;
			diff_x = Math.abs(this.orig_pointX - e.clientX);
			diff_y = Math.abs(this.orig_pointY - e.clientY);
			if (diff_x < 2 || diff_y < 2) {
				this.allow_click = true;
			} else {
				this.allow_click = false;
			}
		});

		this.$refs.container_svg.addEventListener('touchend', (e) => {
			let diff_x, diff_y;
			this.panning = false;
			diff_x = Math.abs(this.orig_pointX - e.changedTouches[0].clientX);
			diff_y = Math.abs(this.orig_pointY - e.changedTouches[0].clientY);
			if (diff_x < 2 || diff_y < 2) {
				this.allow_click = true;
			} else {
				this.allow_click = false;
			}
		});

		this.$refs.container_svg.addEventListener('mouseleave', (e) => {
			this.panning = false;
		});
		this.$refs.container_svg.addEventListener('mousemove', (e) => {
			e.preventDefault();

			if (!this.panning) {
				return;
			}
			this.$refs.container_svg.classList.remove('is-zoomed');
			this.$refs.container_svg.classList.remove('is-transit');

			this.pointX = e.clientX - this.start.x;
			this.pointY = e.clientY - this.start.y;
			this.limit_panning(false);
			this.set_pos();
		});

		this.$refs.container_svg.addEventListener(
			'touchmove',
			(e) => {
				e.preventDefault();

				if (!this.panning) {
					return;
				}
				this.$refs.container_svg.classList.remove('is-zoomed');
				this.$refs.container_svg.classList.remove('is-transit');
				if (this.pinched) {
					this.$refs.container_svg.classList.remove('is-transit');
					this.pinch(e);
					this.$refs.container_svg.classList.add('is-zoomed');
				} else {
					this.pointX = e.touches[0].clientX - this.start.x;
					this.pointY = e.touches[0].clientY - this.start.y;
					this.limit_panning(false);
				}
				this.set_pos();
			},
			{ passive: false }
		);

		window.addEventListener('keydown', (e) => {
			if (e.key === 'Control') {
				this.ctrl_clicked = true;
			}
		});
		window.addEventListener('keyup', (e) => {
			if (e.key === 'Control') {
				this.ctrl_clicked = false;
			}
		});

		this.$refs.container.addEventListener('wheel', (e) => {
			this.$refs.container_svg.classList.remove('is-transit');
			e.preventDefault();

			if (this.windowWidth >= 768) this.zoom_in(e);

			this.set_pos();
		});
	},

	methods: {
		get_tags(cats) {
			return this.$store.state.main.indx.terms.store_categories.filter((cat) =>
				cats.includes(cat.id)
			);
		},
		select_store_search(card) {
			this.change_floor(card.floor[0]);
			this.active_floor = parseInt(card.floor[0]);
			this.$nextTick(() => {
				let act;
				let rects = [...document.querySelectorAll('.map__content rect')].filter(
					(el) => el.getAttribute('room') && parseInt(el.getAttribute('room')) !== card.id
				);
				let polygons = [...document.querySelectorAll('.map__content polygon')].filter(
					(el) => el.getAttribute('room') && parseInt(el.getAttribute('room')) !== card.id
				);
				let paths = [...document.querySelectorAll('.map__content path')].filter(
					(el) => el.getAttribute('room') && parseInt(el.getAttribute('room')) !== card.id
				);

				let rects_act = [...document.querySelectorAll('.map__content rect')].filter(
					(el) => el.getAttribute('room') && parseInt(el.getAttribute('room')) == card.id
				);
				let polygons_act = [...document.querySelectorAll('.map__content polygon')].filter(
					(el) => el.getAttribute('room') && parseInt(el.getAttribute('room')) == card.id
				);
				let paths_act = [...document.querySelectorAll('.map__content path')].filter(
					(el) => el.getAttribute('room') && parseInt(el.getAttribute('room')) == card.id
				);

				if (rects_act.length >= 1) {
					act = rects_act[0];
				} else if (polygons_act.length >= 1) {
					act = polygons_act[0];
				} else if (paths_act.length >= 1) {
					act = paths_act[0];
				}
				act.style.fill = `${act.getAttribute('stroke_color')}6E`;
				act.style.stroke = `${act.getAttribute('stroke_color')}`;
				act.style.strokeWidth = 10;
				act.style.pointerEvents = 'all';
				act.style.opacity = '1';
				act.classList.remove('disabled');

				rects.forEach((elm) => {
					elm.style.fill = '#2C3140';
					elm.style.stroke = '#2C3140';
					elm.style.strokeWidth = 0;
					elm.style.pointerEvents = 'none';
					elm.classList.add('disabled');
					elm.style.opacity = '0.8';
				});

				polygons.forEach((elm) => {
					elm.style.fill = '#2C3140';
					elm.style.stroke = '#2C3140';
					elm.style.strokeWidth = 0;
					elm.style.pointerEvents = 'none';
					elm.classList.add('disabled');
					elm.style.opacity = '0.8';
				});

				paths.forEach((elm) => {
					elm.style.fill = '#2C3140';
					elm.style.stroke = '#2C3140';
					elm.style.strokeWidth = 0;
					elm.style.pointerEvents = 'none';
					elm.classList.add('disabled');
					elm.style.opacity = '0.8';
				});

				this.$store.commit('main/setState', { key: 'search_typed', val: '' });
			});
		},

		disable_stores(id) {
			let rects = [...document.querySelectorAll('.map__content rect')].filter(
				(el) => el.getAttribute('cat_id') && !JSON.parse(el.getAttribute('cat_ids')).includes(id)
			);
			let polygons = [...document.querySelectorAll('.map__content polygon')].filter(
				(el) => el.getAttribute('cat_id') && !JSON.parse(el.getAttribute('cat_ids')).includes(id)
			);
			polygons.forEach((p) => {
				console.log(JSON.parse(p.getAttribute('cat_ids')));
			});
			let paths = [...document.querySelectorAll('.map__content path')].filter(
				(el) => el.getAttribute('cat_id') && !JSON.parse(el.getAttribute('cat_ids')).includes(id)
			);

			//
			//   console.log(id)
			// console.log(polygons)
			// console.log(rects)
			// console.log(paths)
			let active_rects = [...document.querySelectorAll('.map__content rect')].filter(
				(el) => el.getAttribute('cat_id') && JSON.parse(el.getAttribute('cat_ids')).includes(id)
			);
			let active_polygons = [...document.querySelectorAll('.map__content polygon')].filter(
				(el) => el.getAttribute('cat_id') && JSON.parse(el.getAttribute('cat_ids')).includes(id)
			);
			let active_paths = [...document.querySelectorAll('.map__content path')].filter(
				(el) => el.getAttribute('cat_id') && JSON.parse(el.getAttribute('cat_ids')).includes(id)
			);
			rects.forEach((elm) => {
				elm.style.fill = '#2C3140';
				elm.style.stroke = '#2C3140';
				elm.style.strokeWidth = 0;
				elm.style.pointerEvents = 'none';
				elm.classList.add('disabled');
				elm.style.opacity = '0.8';
			});

			polygons.forEach((elm) => {
				elm.style.fill = '#2C3140';
				elm.style.stroke = '#2C3140';
				elm.style.strokeWidth = 0;
				elm.style.pointerEvents = 'none';
				elm.classList.add('disabled');
				elm.style.opacity = '0.8';
			});

			paths.forEach((elm) => {
				elm.style.fill = '#2C3140';
				elm.style.stroke = '#2C3140';
				elm.style.strokeWidth = 0;
				elm.style.pointerEvents = 'none';
				elm.classList.add('disabled');
				elm.style.opacity = '0.8';
			});

			active_rects.forEach((elm) => {
				elm.style.fill = `${elm.getAttribute('fill_color')}`;
				elm.style.stroke = `${elm.getAttribute('fill_color')}`;
				elm.style.strokeWidth = 10;
				elm.style.pointerEvents = 'all';
				elm.classList.remove('disabled');
				elm.style.opacity = '0';
			});

			active_polygons.forEach((elm) => {
				elm.style.fill = `${elm.getAttribute('fill_color')}`;
				elm.style.stroke = `${elm.getAttribute('fill_color')}`;
				elm.style.strokeWidth = 10;
				elm.style.pointerEvents = 'all';
				elm.classList.remove('disabled');
				elm.style.opacity = '0';
			});

			active_paths.forEach((elm) => {
				elm.style.fill = `${elm.getAttribute('fill_color')}`;
				elm.style.stroke = `${elm.getAttribute('fill_color')}`;
				elm.style.strokeWidth = 10;
				elm.style.pointerEvents = 'all';
				elm.classList.remove('disabled');
				elm.style.opacity = '0';
			});
		},
		set_radio_color(color, border_color) {
			document.querySelector(
				'.el-radio__input.is-checked .el-radio__inner'
			).style.borderColor = `${border_color}`;
			document.querySelector(
				'.el-radio__input.is-checked .el-radio__inner'
			).style.background = `${color}`;
		},
		assign_colors(elem) {
			elem.forEach((tag_name) => {
				let _store, _color, stroke_color;
				if (tag_name.getAttribute('room') && tag_name.getAttribute('room') !== '-') {
					_store = this.list.filter((L) => L.id === parseInt(tag_name.getAttribute('room')));
					if (_store.length !== 0) {
						// console.log( _store[0])

						_color = _.get(_store[0], 'cat_data[0].color.fill_color');
						stroke_color = _.get(_store[0], 'cat_data[0].color.stroke_color');
					}
					tag_name.style.stroke = `${stroke_color}`;
					tag_name.style.strokeWidth = 10;
					let ids = [];
					if (_store.length !== 0) {
						_store[0].cat_data.forEach((_id) => {
							ids.push(_id.id);
						});

						tag_name.setAttribute('fill_color', `${_color}`);
						tag_name.setAttribute('hover_color', `${stroke_color}`);
						tag_name.setAttribute('cat_id', `${_store[0].cat_data[0].id}`);
						tag_name.setAttribute('cat_ids', `[${ids}]`);
					}
				}
			});

			let radios = document.querySelectorAll('.map__filters--radio_box');
			radios.forEach((radio) => {
				radio.querySelector('.el-radio__inner').style.border = `2px solid ${radio.getAttribute(
					'stroke_color'
				)}`;
				radio.querySelector('.el-radio__inner').style.borderColor = `${radio.getAttribute(
					'stroke_color'
				)}`;
				radio.querySelector('.el-radio__inner').style.background = `${radio.getAttribute(
					'fill_color'
				)}`;
			});
		},
		get_store_data_2(ev) {
			if (this.allow_click) {
				let T = ev.currentTarget,
					ID = ev.currentTarget.getAttribute('room'),
					slctd;
				slctd = this.list.filter((L) => L.id == ID);
				this.selected_store = slctd[0];

				this.$store.commit('main/setState', { key: 'store_pop_up', val: true });
				this.$store.commit('main/setState', {
					key: 'store_modal_data',
					val: this.selected_store,
				});
			}
		},
		get_store_data(ev) {
			let T = ev.currentTarget;
			T.style.fill = `${T.getAttribute('hover_color')}6E`;
			T.style.stroke = `${T.getAttribute('hover_color')}`;
			T.style.opacity = 1;
		},
		mouse_leave(ev) {
			let T = ev.currentTarget;
			if (!T.classList.contains('disabled')) {
				T.style.fill = 'transparent';
				T.style.opacity = 0;
			}
		},
		assign_values(m_svg) {
			console.log('ksjklsjakdlsjakldjsa');
			let svg = _.get(m_svg, 'render_svg'),
				spaces = _.get(m_svg, 'selected_rooms'),
				space_ids = [],
				rects,
				polygons,
				paths,
				polyline,
				rects_pointer_none,
				polygons_pointer_none,
				paths_pointer_none,
				polyline_pointer_none;

			this.list = _.get(this.contentData, 'data.list');
			spaces = spaces.filter(
				(space) => space.room_id !== null && space.room_id !== '-' && space.room_id !== 'undefined'
			);

			for (let j = 0; j < spaces.length; j++) {
				space_ids.push(parseInt(spaces[j].room_id));
			}
			this.list = this.list.filter((L) => space_ids.includes(L.id));
			rects_pointer_none = [...document.querySelectorAll('.map__content rect')].filter(
				(el) => !el.getAttribute('room')
			);
			polygons_pointer_none = [...document.querySelectorAll('.map__content polygon')].filter(
				(el) => !el.getAttribute('room')
			);
			paths_pointer_none = [...document.querySelectorAll('.map__content path')].filter(
				(el) => !el.getAttribute('room')
			);
			polyline_pointer_none = [...document.querySelectorAll('.map__content polyline')].filter(
				(el) => !el.getAttribute('room')
			);

			rects_pointer_none.forEach((el) => {
				el.style.pointerEvents = 'none';
			});

			polygons_pointer_none.forEach((el) => {
				el.style.pointerEvents = 'none';
			});

			paths_pointer_none.forEach((el) => {
				el.style.pointerEvents = 'none';
			});

			polyline_pointer_none.forEach((el) => {
				el.style.pointerEvents = 'none';
			});

			rects = [...document.querySelectorAll('.map__content rect')].filter((el) =>
				el.getAttribute('room')
			);

			polygons = [...document.querySelectorAll('.map__content polygon')].filter((el) =>
				el.getAttribute('room')
			);

			paths = [...document.querySelectorAll('.map__content path')].filter((el) =>
				el.getAttribute('room')
			);

			for (let j = 0; j < this.list.length; j++) {
				let color = this.$store.state.main.indx.terms.store_categories.filter(
					(cat) => cat.pid == 0 && cat.color && this.list[j].store_categories.includes(cat.id)
				);
				this.list[j].cat_data = color;
			}
			this.assign_colors(rects);
			this.assign_colors(polygons);
			this.assign_colors(paths);

			rects.forEach((elm) => {
				elm.addEventListener('mouseenter', this.get_store_data);
				elm.addEventListener('click', this.get_store_data_2);
			});
			polygons.forEach((elm) => {
				elm.addEventListener('mouseenter', this.get_store_data);
				elm.addEventListener('click', this.get_store_data_2);
			});
			paths.forEach((elm) => {
				elm.addEventListener('mouseenter', this.get_store_data);
				elm.addEventListener('click', this.get_store_data_2);
			});

			rects.forEach((elm) => {
				elm.addEventListener('mouseleave', this.mouse_leave);
			});
			polygons.forEach((elm) => {
				elm.addEventListener('mouseleave', this.mouse_leave);
			});
			paths.forEach((elm) => {
				elm.addEventListener('mouseleave', this.mouse_leave);
			});
		},
		set_pos() {
			this.$refs.container_svg.style.transform =
				'translate(' + this.pointX + 'px, ' + this.pointY + 'px) scale(' + this.scale + ')';
		},

		zoom_in(e) {
			let clientX = e.clientX - this.$refs.container.getBoundingClientRect().left;
			let clientY = e.clientY - this.$refs.container.getBoundingClientRect().top;
			let xs = (clientX - this.pointX) / this.scale,
				ys = (clientY - this.pointY) / this.scale,
				delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
			if (this.windowWidth >= 1001) {
				if (delta > 0 && this.scale * 1.1 <= 3.1) {
					this.scale *= 1.1;
				} else if (delta < 0 && this.scale / 1.1 >= 1) {
					this.scale /= 1.1;
				}
			} else {
				if (delta > 0 && this.scale * 1.1 <= 3.3) {
					this.scale *= 1.1;
				} else if (delta < 0 && this.scale / 1.1 >= 1) {
					this.scale /= 1.1;
				}
			}

			this.pointX = clientX - xs * this.scale;
			this.pointY = clientY - ys * this.scale;
			this.$refs.container_svg.classList.add('is-zoomed');
		},

		pinch(evs) {
			let clientX_1 = evs.touches[0].clientX - this.$refs.container.getBoundingClientRect().left;
			let clientX_2 = evs.touches[1].clientX - this.$refs.container.getBoundingClientRect().left;
			let clientY_1 = evs.touches[0].clientY - this.$refs.container.getBoundingClientRect().top;
			let clientY_2 = evs.touches[1].clientY - this.$refs.container.getBoundingClientRect().top;

			let d = Math.hypot(
				evs.touches[0].pageX - evs.touches[1].pageX,
				evs.touches[0].pageY - evs.touches[1].pageY
			);
			let xs = ((clientX_1 + clientX_2) / 2 - this.pointX) / this.scale;
			let ys = ((clientY_1 + clientY_2) / 2 - this.pointY) / this.scale;

			if (d > this.start_dist) {
				if (this.scale * 1.1 > 3.8) {
					this.scale = 3.8;
				} else {
					this.scale *= 1.1;
				}
			} else {
				if (this.scale / 1.1 >= 1) {
					this.scale /= 1.1;
				}
			}

			this.pointX = (clientX_1 + clientX_2) / 2 - xs * this.scale;
			this.pointY = (clientY_1 + clientY_2) / 2 - ys * this.scale;
			this.$refs.container_svg.classList.add('is-zoomed');
		},

		limit_panning(zoom_out) {
			let return_pos_val;
			let limit_val_x = this.$refs.container_svg.getBoundingClientRect().width * 0.24,
				limit_val_y = this.$refs.container_svg.getBoundingClientRect().height * 0.24;
			if (this.windowWidth >= 1024) {
				return_pos_val = !zoom_out
					? 250
					: this.$refs.container_svg.getBoundingClientRect().bottom -
					  this.$refs.container.getBoundingClientRect().bottom -
					  (this.$refs.container_svg.getBoundingClientRect().top -
							this.$refs.container.getBoundingClientRect().top);
			} else {
				return_pos_val = !zoom_out
					? 100
					: this.$refs.container_svg.getBoundingClientRect().bottom -
					  this.$refs.container.getBoundingClientRect().bottom -
					  (this.$refs.container_svg.getBoundingClientRect().top -
							this.$refs.container.getBoundingClientRect().top);
			}

			if (
				this.$refs.container_svg.getBoundingClientRect().left < 0 &&
				Math.abs(this.$refs.container_svg.getBoundingClientRect().left) >
					this.$refs.container_svg.getBoundingClientRect().width - limit_val_x
			) {
				this.pointX = this.pointX + return_pos_val;
				this.$refs.container_svg.classList.add('is-transit');
				this.panning = false;
			} else if (
				this.$refs.container_svg.getBoundingClientRect().right >=
				this.windowWidth + (this.$refs.container_svg.getBoundingClientRect().width - limit_val_x)
			) {
				this.pointX = this.pointX - return_pos_val;
				this.$refs.container_svg.classList.add('is-transit');
				this.panning = false;
			} else if (
				this.$refs.container_svg.getBoundingClientRect().top -
					this.$refs.container.getBoundingClientRect().top <
					0 &&
				Math.abs(
					this.$refs.container_svg.getBoundingClientRect().top -
						this.$refs.container.getBoundingClientRect().top
				) >
					this.$refs.container_svg.getBoundingClientRect().height - limit_val_y
			) {
				this.pointY = this.pointY + return_pos_val;
				this.$refs.container_svg.classList.add('is-transit');
				this.panning = false;
			} else if (
				this.$refs.container_svg.getBoundingClientRect().top -
					this.$refs.container.getBoundingClientRect().top >
					0 &&
				Math.abs(
					this.$refs.container_svg.getBoundingClientRect().top -
						this.$refs.container.getBoundingClientRect().top
				) >
					this.$refs.container.getBoundingClientRect().bottom -
						this.$refs.container.getBoundingClientRect().top -
						limit_val_y
			) {
				this.pointY = this.pointY - return_pos_val;
				this.$refs.container_svg.classList.add('is-transit');
				this.panning = false;
			}
		},
		resize_handler() {
			this.windowWidth = window.innerWidth;
			this.windowHeight = window.innerHeight;
		},
		async get_map_data() {
			let res = await fn.postData('main/getProjects', {
				id: this.project_id,
			});

			let res_data_floors = [];
			res.data.floors.forEach((floor) => {
				floor.title = parseInt(floor.title);
				res_data_floors.push(floor.title);
			});
			this.map_data = res.data.floors;

			let _floors = this.$store.state.main.indx.terms.floors.filter((fl) =>
				res_data_floors.includes(fl.id)
			);

			this.floors = _floors.sort((a, b) => parseInt(a.floor_num[0]) - parseInt(b.floor_num[0]));
			res.data.floors.forEach((floor) => {
				console.log(parseInt(floor.title));
			});

			this.active_floor = parseInt(this.floors[0].id);
			this.map_svg = res.data.floors.filter(
				(floor) => floor.title == this.floors[0].id
			)[0].render.tabs[0];
		},

		change_floor(ns) {
			let map_svg = this.map_data.filter(
				(floor) => parseInt(floor.title) == ns,
				(this.changed_floor = true)
			);
			this.map_svg = map_svg[0].render.tabs[0];
			this.$nextTick(() => {
				this.assign_values(map_svg[0].render.tabs[0]);
			});
		},
		getFloor(floorId) {
			const floorWidget = this.$store.state.main.indx.terms.floors;
			const res = [];
			floorId.length
				? floorId.forEach((floor) => {
						res.push(floorWidget.find((item) => item.id == floor));
				  })
				: '';
			return res;
		},
	},
	computed: {
		project_id() {
			return this.$store.state.main.indx.terms.project.filter(
				(pr) => pr.slug === this.$route.params.path1
			)[0].id;
		},
		double_checker() {
			let arr = [_.get(this.contentData, 'data.list'), this.map_svg];
			return arr;
		},
		store_modal() {
			return this.$store.state.main.store_pop_up;
		},
		store_categories() {
			let act = this.active_floor.toString();
			return this.$store.state.main.indx.terms.store_categories.filter(
				(cat) => cat.pid == 0 && cat.floor && cat.floor.includes(act)
			);
		},
		get_unic_id() {
			return _.get(this.contentData, 'conf.unicId');
		},

		search_list() {
			return this.$store.state.main.search_list;
		},
		search_val() {
			return this.$store.state.main.search_typed;
		},
		list_content() {
			return this.$store.state.main.list_content_data;
		},
	},
	watch: {
		list_content: {
			immediate: true,
			deep: true,
			handler(val) {
				if (!val) {
					this.$store.commit('main/setState', {
						key: 'list_content_data',
						val: this.contentData,
					});
				}
			},
		},
		project_id: {
			immediate: true,
			handler(ns) {},
		},

		double_checker: {
			immediate: true,
			deep: true,
			handler(ns) {
				let _svg = document.querySelector('.map-content svg');
				console.log(ns);
				if (ns[0] && ns[1] && ns[0] !== undefined && ns[1] !== undefined) {
					console.log('klsajldjsalkdjsa');

					this.$nextTick(() => {
						this.assign_values(this.map_svg);
					});
				}
			},
		},
		radio(ns, os) {
			this.disable_stores(ns);
		},
		panning(ns, os) {
			ns == true
				? document.querySelector('body').classList.add('grabbing')
				: document.querySelector('body').classList.remove('grabbing');
		},

		search_list(ns, os) {
			this.filteredList = ns.data.list;
		},

		get_unic_id: {
			immediate: true,
			handler(ns) {
				this.$store.commit('main/setState', {
					key: 'unique_id',
					val: ns,
				});
				this.$store.commit('main/setState', {
					key: 'per_page',
					val: 1000,
				});
			},
		},

		search_val(ns, os) {
			if (ns.length >= 1) {
				document.body.classList.add('hide_scroll');
				document.querySelector('.search').classList.remove('floors_page');
				this.$nextTick(() => {
					this.$refs.floors_search.style.height = `${this.windowHeight -
						document.querySelector('.search').getBoundingClientRect().bottom}px`;
				});
			} else {
				document.body.classList.remove('hide_scroll');
				document.querySelector('.search').classList.add('floors_page');
			}
		},
		windowHeight(ns, os) {
			this.$refs.floors_search.style.height = `${this.windowHeight -
				document.querySelector('.search').getBoundingClientRect().bottom}px`;
		},
		active_floor(ns) {
			if (
				this.double_checker[0] &&
				this.double_checker[1] &&
				this.double_checker[0] !== undefined &&
				this.double_checker[1] !== undefined
			) {
				this.radio = [];
				this.change_floor(ns);
			}
		},
	},
};
</script>

<style lang="scss">
.floors_wrapper {
	position: relative;
}
.floors_search {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;

	&__wrapper {
		position: relative;
		height: 100%;
		overflow-y: scroll;
		background-color: $dirtywhite;
		z-index: 10;
		padding-top: 55px;
		padding-bottom: 91px;
	}
	&__inner {
		grid-template-columns: 1fr 1fr 1fr;
		grid-column-gap: 30px;
		grid-row-gap: 30px;
	}
	&__card {
		position: relative;
		background-color: white;
		&--logo {
			position: relative;
			height: 143px;
			width: 100%;
			border-bottom: 2px solid $border;
			img {
				height: auto;
				width: 100%;
				max-height: 143px;
				max-width: 100%;
			}
		}
		span {
			&:last-child {
				i {
					display: none;
				}
			}
		}
	}
}
body.hide_scroll {
	overflow: hidden;
}
body.panning {
	cursor: grabbing;
}
.map {
	position: relative;
	// height: 1100px;
	// margin-top: 293px;
	height: 80vh;
	padding-top: 55px;
	padding-bottom: 55px;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	overflow: hidden;
	@media (max-width: 1000px) {
		height: auto;
		padding-top: 0;
		padding-bottom: 0;
	}

	rect,
	path,
	polygon {
		transition: 0.4s;
	}
	tspan {
		font-size: 6px;
		font-family: 'Hm-Pangram-medium';
	}
	&__filters {
		position: absolute;
		left: 0;
		width: 277px;
		top: 50%;
		min-height: 170px;
		height: 30vh;
		padding-right: 50px;
		background-color: $black;
		pointer-events: all;
		padding-top: 30px;
		padding-bottom: 30px;
		border: 2px solid $dirtyblue;
		transition: ease-in-out 0.5s;
		max-height: calc(100% - 100px);
		transform: translateX(-200px) translateY(-50%);

		&.collapsed {
			transform: translateX(0) translateY(-50%);
			transition: ease-out 0.5s;
			.map__filters--right-col svg {
				transform: translateX(-50%) rotate(90deg);
			}
		}
		.el-radio__label {
			font-size: 13px;
			// font-family: "Hm-Pangram-bold";
			font-family: 'Firago-Book';
			text-transform: uppercase;
			font-feature-settings: 'case' on;
			white-space: normal;
		}

		&--radio_box {
			.el-radio {
				display: flex;
				align-items: center;
				&__inner {
					height: 20px;
					width: 20px;
					&:after {
						width: 8px;
						height: 8px;
					}
				}
				&__input.is-checked + .el-radio__label {
					color: white;
				}
			}
		}

		&--filter {
			&:not(:last-child) {
				margin-bottom: 20px;
			}
		}
		&--left-col {
			position: relative;
			padding-left: 32px;
			height: 100%;
			overflow-y: auto;
			padding-right: 20px;
			&::-webkit-scrollbar {
				height: 1px;
				width: 4px;
				background: transparent;
			}
			&::-webkit-scrollbar-thumb {
				height: 1px;
				width: 4px;
				background: #575757;
			}
			&::-webkit-scrollbar-track {
				background: rgba(255, 255, 255, 0.1);
			}
			&.collapsed {
				transform: scaleX(1);
			}
		}
		&--right-col {
			// position: relative;
			position: absolute;
			right: 0;
			top: 0;
			width: 54px;
			height: 100%;
			padding-top: 30px;
			span {
				display: block;
				top: 50%;
				left: 4px;
				transform: rotate(-90deg) translateY(-50%);
				position: absolute;
			}
			svg {
				position: absolute;
				top: 30px;
				left: 50%;
				transform: translateX(-50%) rotate(0deg);
				transition: 0.4s;
			}
		}
	}
	&__filter-btn {
		height: 55px;
		width: 55px;
		background-color: $black;
		transition: 0.4s;
		border-top: 2px solid $dirtyblue;
		border-left: 2px solid $dirtyblue;
		border-right: 2px solid $dirtyblue;
		&:last-child {
			border-bottom: 2px solid $dirtyblue;
		}
		@include hover {
			background-color: $blue;
		}
		&.active {
			background-color: $blue;
		}
	}

	&__floors {
		position: absolute;
		right: 50px;
		top: 50%;
		padding-top: 37px;
		transform: translateY(-50%);
		.uppercase {
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
		}
	}
}
body {
	&.touched {
		overflow: hidden;
	}
	.svg_viewer__inner {
		cursor: grab;
	}
	&.grabbing {
		.svg_viewer__inner {
			cursor: grabbing;
		}
	}
}

.zoom_out,
.zoom_in {
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.zoom_in {
	margin-top: 10px;
	pointer-events: all;
}
.zoom_out {
	pointer-events: all;
	height: 55px;
	width: 55px;
}

@media (max-width: 1000px) {
	.map__filter-btn {
		height: 40px;
		width: 40px;
	}
}
.svg_viewer {
	position: relative;
	width: 100%;
	height: auto;
	overflow: hidden;
	&__ui {
		display: flex;
		pointer-events: none;
		width: 100%;
		height: 100%;
		position: absolute;

		top: 0;
		left: 0;

		z-index: 4;
	}
	&__inner {
		position: relative;

		display: flex;
		justify-content: center;
		height: 991px;
		margin: 0 auto;
		cursor: grab;
		&--svg {
			position: absolute;
			width: 100%;
			transform-origin: 0px 0px;
			transform: scale(1) translate(0px, 0px);
			&.is-zoomed {
				transition: 0.15s;
				@include screen(mobile) {
					transition: 0.1s;
				}
			}
			&.is-transit {
				transition: 0.5s;
			}
			height: 100%;
			top: 0;
			left: 0;
		}
		svg {
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;
			polygon,
			rect,
			path {
				will-change: transform;
				fill: transparent;
				opacity: 0;
				transition: 0.3s;
				cursor: pointer;
				&:hover {
					opacity: 1;
				}
			}
		}
	}
}
@media (max-width: 1247px) {
	.svg_viewer {
		&__inner {
			width: 100%;
		}
	}
}
@include screen(tablet) {
	.floors_search {
		&__inner {
			grid-template-columns: 1fr 1fr;
			grid-gap: 15px;
		}
	}
}
@include screen(mobile) {
	.map {
		&__floors {
			right: 0;
			padding-top: 0;

			.uppercase {
				display: none;
			}
		}
	}
	.floors_search {
		&__inner {
			grid-template-columns: 1fr;
			grid-gap: 15px;
		}
	}
}
</style>
